import { render, staticRenderFns } from "./FormSubmissions.vue?vue&type=template&id=fda918fa&scoped=true"
import script from "./FormSubmissions.vue?vue&type=script&lang=js"
export * from "./FormSubmissions.vue?vue&type=script&lang=js"
import style0 from "./FormSubmissions.vue?vue&type=style&index=0&id=fda918fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda918fa",
  null
  
)

export default component.exports